<template>
  <span class="countdown" v-if="remainingTime > 0">
    {{ formattedTime }}
  </span>
  <span class="countdown" v-else>
    {{ endText }}
  </span>
</template>

<script>
export default {
  name: 'CountDown',
  props: {
    // 结束时间戳（毫秒），例如：Date.now() + 60 * 1000
    endTime: {
      type: Number,
      required: true
    },
    // 是否立即启动倒计时
    autoStart: {
      type: Boolean,
      default: true
    },
    // 结束后显示的文案
    endText: {
      type: String,
      default: '已结束'
    }
  },
  data () {
    return {
      timer: null,
      now: Date.now()
    }
  },
  computed: {
    // 剩余毫秒数
    remaining () {
      const diff = this.endTime - this.now
      return diff > 0 ? diff : 0
    },
    // 剩余秒数
    remainingTime () {
      return Math.floor(this.remaining / 1000)
    },
    // 格式化：HH:mm:ss 或 mm:ss
    formattedTime () {
      const total = this.remainingTime
      const d = Math.floor(total / 86400)
      const h = Math.floor((total % 86400) / 3600)
      const m = Math.floor((total % 3600) / 60)
      const s = total % 60

      const pad = n => (n < 10 ? '0' + n : '' + n)

      if (d > 0) {
        return `${d}天${pad(h)}时${pad(m)}分${pad(s)}`
      }
      if (h > 0) return `${pad(h)}时${pad(m)}分${pad(s)}`
      return `${pad(m)}分${pad(s)}`
    }
  },
  watch: {
    // 如果父组件重新传了一个新的结束时间戳，重新开始计时
    endTime () {
      this.reset()
    }
  },
  mounted () {
    if (this.autoStart) {
      this.start()
    }
  },
  beforeDestroy () {
    this.clear()
  },
  methods: {
    start () {
      this.clear()
      // 先更新一次
      this.now = Date.now()
      this.timer = setInterval(() => {
        this.now = Date.now()
        if (this.remaining <= 0) {
          this.clear()
          this.$emit('finish')
        }
      }, 1000)
    },
    reset () {
      this.start()
    },
    clear () {
      if (this.timer) {
        clearInterval(this.timer)
        this.timer = null
      }
    }
  }
}
</script>

<style scoped>
.countdown {
  font-size: 14px;
  color: #FF5900;
}
</style>

